import React, { useState, useEffect } from "react";
// import { Container } from "../components/Grid"
import InventoryGame from "../components/Inventory/inventoryGame";
import ForestWorld from "../features/world/ForestWorld";
import ForestWorldThiefMoved from "../features/world/ForestWorldThiefMoved";
// import Player from '../features/player';
import { useParams, useLocation } from "react-router-dom";
import API from "../utils/API";


function ForestGame() {
  const { id } = useParams();
  const location = useLocation();
  const queryReturn = new URLSearchParams(location.search).get("from") === "shop";
  let storedReturnPosition = null;
  try {
    storedReturnPosition = JSON.parse(sessionStorage.getItem("forestReturnPosition"));
  } catch (error) {
    sessionStorage.removeItem("forestReturnPosition");
  }
  const returningFromShop = queryReturn || Array.isArray(storedReturnPosition);
  const forestStartPosition = Array.isArray(storedReturnPosition) ? storedReturnPosition : [384, 256];

  useEffect(() => {
    sessionStorage.removeItem("forestReturnPosition");
  }, []);

  const [userAvatar, setUserAvatar] = useState(null);
  const [userAvatarName, setUserAvatarName] = useState(null);
  const [thiefTalk, setThiefTalk] = useState(null);

  useEffect(() => {


    const getUserData = async () => {
      const userData = await API.getUser(id);
      const user = await userData.json();
      const { sprite, name, apiFirstThiefTalk } = user.sprite[0];

      setUserAvatar(sprite);
      setUserAvatarName(name);
      setThiefTalk(apiFirstThiefTalk);
    };

    getUserData();
  }, []);

  function renderForest() {
    switch (thiefTalk) {
      case true:
        return <ForestWorld avatar={userAvatar} avatarName={userAvatarName} initialPosition={returningFromShop ? forestStartPosition : undefined} />;
      case false:
        return (
          <ForestWorldThiefMoved
            avatar={userAvatar}
            avatarName={userAvatarName}
            initialPosition={returningFromShop ? forestStartPosition : undefined}
          />
        );
    }
  }
  return (
    <div>
      <div>
        {/* Game Board */}
        {renderForest()}
      </div>

    </div>
  );
}

export default ForestGame;
